import { defineComponent } from "vue";
import { Container } from "aurelia-dependency-injection";
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import moment from "moment";

import { BranchesService } from "../../../services/branches-service";
import { ToastrService } from "../../../services/toastr.service";
import { CentralIntakeService } from "../../../services/central-intake.service";
import { IPromptOptions } from "../../vue-interfaces/i-prompt";
import { IBranchResponse } from "../../vue-interfaces/i-branch";

import DatePicker from "../../vue-custom-elements/DatePicker/DatePicker.vue";
import Prompt from "../prompt/prompt.vue";

export default defineComponent({
    components: {
        DatePicker
    },

    inject: ["dialogRef"],

    data(vm) {
        return {
            _toastrService: null as ToastrService,
            _centralIntakeService: null as CentralIntakeService,
            _branchesService: null as BranchesService,
            referralDetails: null,
            dialogReference: this.dialogRef as any,
            branchesLoading: false as boolean,
            agencyBranches: [],
            allBranchList: [] as IBranchResponse[],
            selectedAgencyBranch: null as string,
            effectiveDate: null as string,
            v$: useVuelidate(),
            comments: "" as string,
            isSaving: false as boolean
        };
    },

    validations() {
        return {
            effectiveDate: { required },
            selectedAgencyBranch: { required }
        };
    },

    created() {
        this._toastrService = Container.instance.get(ToastrService);
        this._centralIntakeService = Container.instance.get(CentralIntakeService);
        this._branchesService = Container.instance.get(BranchesService);
        this.referralDetails = this.dialogReference.data.referralDetails;
    },

    async mounted() {
        this.allBranchList = await this._branchesService.getAllBranches();
        this.agencyBranches = this.allBranchList.filter(
            (branch) => branch.accountId === this.referralDetails.accountId
        );
    },

    methods: {
        closeDialog() {
            this.dialogReference.close();
        },

        changeDate(date: any, name: string) {
            this.effectiveDate = date;
        },

        handleCancel() {
            this.dialogReference.close();
            this.effectiveDate = null;
            this.selectedAgencyBranch = null;
            this.comments = "";
        },

        async handleAddBranch() {
            const validated = await this.v$.$validate();
            if (validated) {
                const payload = {
                    AgencyId: this.referralDetails.accountId,
                    Application: this.referralDetails.application,
                    Comment: this.comments,
                    EffectiveDate: this.effectiveDate,
                    AgencyLocationId: this.selectedAgencyBranch,
                    ReferralId: this.referralDetails.id
                };
                let promptOptions: IPromptOptions = {
                    message:
                        "All documentation will reflect the updated branch information starting from the branch’s effective date. Do you want to save this branch?",
                    okText: "Yes",
                    cancelText: "No"
                };
                this.$dialog.open(Prompt, {
                    props: {
                        modal: true,
                        contentStyle: {
                            overflowX: "hidden"
                        },
                        showHeader: false
                    },
                    data: {
                        promptOptions
                    },
                    onClose: async (confirm) => {
                        if (confirm.data === "success") {
                            this.isSaving = true;
                            try {
                                const response = await this._centralIntakeService.addReferralAgencyBranch(payload);
                                this._toastrService.success({
                                    title: "Success",
                                    message: `${response.ErrorMessage}`
                                });
                            } catch (err) {
                                console.error(err);
                                this._toastrService.error({
                                    title: "Failed",
                                    message: `Failed to Add Inquiry Branch.Try Again !! `
                                });
                            } finally {
                                this.isSaving = false;
                                this.dialogReference.close();
                            }
                        }
                    }
                });
            } else {
                this._toastrService.error({
                    title: "Validation error",
                    message: "Please fill required fields"
                });
            }
        }
    }
});
